import React from 'react';

const If = ({condition, children}) => (
    <React.Fragment>
        {condition ? children : null}
    </React.Fragment>
);

export {If};



// WEBPACK FOOTER //
// ./src/view/If.js